import { ReactComponent as Component } from './logo.svg';
export default Component;
